import * as React from 'react';

import { Button, Modal, Typography } from 'antd';

import type { AddressKitInfo } from 'v2/interfaces/addressKit';

type ConfirmAddressProps = {
  isOpen: boolean;
  setIsOpen: (prev: boolean) => void;
  data: AddressKitInfo;
};

const ConfirmAddress = ({ isOpen, setIsOpen, data: { name } }: ConfirmAddressProps) => {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      width={650}
      title='Confirmação de endereço recebida!'
      footer={
        <div className='flex justify-end'>
          <Button type='primary' onClick={handleClose}>
            Fechar
          </Button>
        </div>
      }
    >
      <div className='flex flex-col gap-3'>
        <Typography.Text strong>Olá {name},</Typography.Text>
        <Typography.Paragraph className='mb-0'>
          Agradecemos por confirmar que seu endereço permanece o mesmo. Sua atenção aos detalhes nos ajuda a garantir
          que seus brindes e reconhecimentos cheguem corretamente.
        </Typography.Paragraph>
        <Typography.Paragraph className='mb-0'>
          Em breve, você receberá seus prêmios diretamente no endereço confirmado.
        </Typography.Paragraph>
        <Typography.Paragraph className='mb-0'>
          Continue alcançando grandes sucessos no Programa Elite!
        </Typography.Paragraph>
      </div>
    </Modal>
  );
};

export default ConfirmAddress;
